var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"xWxMn-WyTAqpeOUP78f9-"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["commit-action-front-end"]={id:"xWxMn-WyTAqpeOUP78f9-"};
      